import React from "react";

const S = {
  page: { background: "#f8fafc", minHeight: "100vh", padding: "0 0 60px", textAlign: "left" },
  hero: {
    background: "linear-gradient(135deg, #0ea5a3 0%, #0f766e 100%)",
    color: "#fff",
    padding: "48px 24px 40px",
    textAlign: "left",
  },
  heroInner: { maxWidth: 780, margin: "0 auto" },
  eyebrow: { fontSize: 13, fontWeight: 700, letterSpacing: 1, opacity: 0.85, textTransform: "uppercase" },
  h1: { fontSize: 30, fontWeight: 800, margin: "8px 0 6px", lineHeight: 1.25 },
  h1Sub: { fontSize: 16, opacity: 0.92, margin: 0 },
  container: { maxWidth: 780, margin: "-24px auto 0", padding: "0 24px" },
  card: {
    background: "#fff",
    borderRadius: 14,
    boxShadow: "0 1px 3px rgba(15,23,42,0.08), 0 8px 24px rgba(15,23,42,0.06)",
    padding: "28px 28px 8px",
    marginBottom: 20,
  },
  section: { marginBottom: 24 },
  sectionHead: { display: "flex", alignItems: "center", gap: 10, marginBottom: 10 },
  icon: { fontSize: 20, lineHeight: 1 },
  h2: { fontSize: 18, fontWeight: 700, color: "#0f172a", margin: 0 },
  p: { fontSize: 15, lineHeight: 1.7, color: "#334155", margin: "0 0 10px" },
  divider: { border: "none", borderTop: "1px solid #e2e8f0", margin: "0 0 24px" },
  footerNote: { fontSize: 12, color: "#94a3b8", textAlign: "center", marginTop: 24 },
};

const Section = ({ icon, title, children, last }) => (
  <div style={S.section}>
    <div style={S.sectionHead}>
      <span style={S.icon}>{icon}</span>
      <h2 style={S.h2}>{title}</h2>
    </div>
    {children}
    {!last && <hr style={S.divider} />}
  </div>
);

const Policy = () => (
  <div style={S.page}>
    <div style={S.hero}>
      <div style={S.heroInner}>
        <div style={S.eyebrow}>Resshare</div>
        <h1 style={S.h1}>Chính sách quyền riêng tư</h1>
        <p style={S.h1Sub}>Privacy Policy</p>
      </div>
    </div>

    <div style={S.container}>
      <div style={S.card}>
        <Section icon="🔒" title="Dữ liệu cá nhân và nhạy cảm của người dùng" last>
          <p style={S.p}>
            Dữ liệu riêng tư và nhạy cảm của người dùng bao gồm thông tin nhận dạng cá nhân, thông
            tin xác thực, thông tin liên hệ, thông tin vị trí của thiết bị, micrô, máy ảnh. Chúng
            tôi chỉ được truy cập, thu thập, sử dụng và chia sẻ dữ liệu riêng tư và nhạy cảm của
            người dùng có được qua ứng dụng cho những mục đích liên quan trực tiếp đến việc cung
            cấp và cải thiện tính năng của ứng dụng.
          </p>
          <p style={S.p}>
            Chúng tôi xử lý an toàn tất cả dữ liệu riêng tư và nhạy cảm của người dùng, bao gồm cả
            hoạt động truyền dữ liệu đó bằng phương thức mã hóa hiện đại (qua HTTPS). Ứng dụng yêu
            cầu quyền khi bắt đầu chạy, trước khi truy cập dữ liệu do các quyền của Android kiểm
            soát. Chúng tôi cam kết không bán dữ liệu riêng tư và nhạy cảm của người dùng.
          </p>
        </Section>
      </div>

      <p style={S.footerNote}>© Resshare — Saola Information Technology</p>
    </div>
  </div>
);

export default Policy;
